import { EFlatStatsStatus } from '../../types/flatStats';
import { IApplicationState } from '../../types/redux';

export function selectAddress(state: IApplicationState) {
  return state.fieldsState.address;
}

export function selectChangeAddressPending(state: IApplicationState) {
  return state.flatStats.status === EFlatStatsStatus.Loading;
}
